function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 0.359985V0.839985V17.64H24V0.359985H0ZM0.96 1.31999H23.04V2.5228C22.8363 2.7003 14.3106 10.1309 13.6012 10.7484C12.9786 11.2905 12.3443 11.4009 12 11.4009C11.656 11.4009 11.0215 11.2906 10.3987 10.7484C9.68937 10.1309 1.16366 2.7003 0.96 2.5228V1.31999ZM0.96 3.79217C2.13023 4.81225 9.10447 10.8921 9.76969 11.4712C10.586 12.1819 11.4502 12.359 12 12.359C12.5494 12.359 13.4139 12.182 14.2303 11.4712C14.8955 10.8921 21.8697 4.81311 23.04 3.79311V16.68H0.96V3.79217Z",
  fill: "#9499A2"
});

var SvgIcoEmail = function SvgIcoEmail(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoEmail, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_email.c7be1a0b.svg";
export { ForwardRef as ReactComponent };